module.exports = __webpack_public_path__ + "media/images/icons/wizard/progress/middle-39d9955363ec07f23c683cc19e837de1.svg";